import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';
import { Heart, ShoppingCart, TrendingUp, Users } from 'lucide-react';

import css from './SocialProofBadges.module.css';

const SocialProofBadges = props => {
  const {
    className,
    rootClassName,
    recent24hViewCount = 0,
    liveViewerCount = 0,
    wishlistCount = 0,
    cartCount = 0,
    showTrending = false,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  if (
    !recent24hViewCount &&
    !liveViewerCount &&
    !wishlistCount &&
    !cartCount &&
    !showTrending
  ) {
    return null;
  }

  return (
    <div className={classes}>
      {recent24hViewCount > 0 ? (
        <p className={css.headline}>
          <FormattedMessage
            id="SocialProofBadges.recent24hHeadline"
            defaultMessage="{count} viewed in the last 24 hours"
            values={{ count: recent24hViewCount }}
          />
        </p>
      ) : null}

      <div className={css.metrics}>
        {liveViewerCount > 0 ? (
          <div className={css.metric}>
            <Users className={css.metricIcon} />
            <span className={css.metricText}>
              <FormattedMessage
                id="SocialProofBadges.liveViewers"
                defaultMessage="{count} viewing now"
                values={{ count: liveViewerCount }}
              />
            </span>
          </div>
        ) : null}

        {wishlistCount > 0 ? (
          <div className={css.metric}>
            <Heart className={css.metricIcon} />
            <span className={css.metricText}>
              <FormattedMessage
                id="SocialProofBadges.savedCount"
                defaultMessage="{count} saved"
                values={{ count: wishlistCount }}
              />
            </span>
          </div>
        ) : null}

        {cartCount > 0 ? (
          <div className={css.metric}>
            <ShoppingCart className={css.metricIcon} />
            <span className={css.metricText}>
              <FormattedMessage
                id="SocialProofBadges.cartCount"
                defaultMessage="{count} in carts"
                values={{ count: cartCount }}
              />
            </span>
          </div>
        ) : null}

        {showTrending ? (
          <div className={classNames(css.metric, css.metricTrending)}>
            <TrendingUp className={css.metricIcon} />
            <span className={css.metricText}>Trending</span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default SocialProofBadges;
